import Api from '@/services/Api';
import EventBus from '@/services/event-bus';
import countryTranslationServiceEs from '../../i18n/translated_countries_service_es';

export default {
  namespaced: true,
  state: {
    sampleTypes: [],
    originCountries: [],
    destinationCountries: [],
  },
  actions: {
    async getSampleTypesSat({ commit, rootState }, params) {
      try {
        const xhr = await Api.getSampleTypesFromSatellite(
          params,
          rootState.contact.company
        );
        const response = JSON.parse(xhr.response);
        const sampleTypesMapped = response.map((s) => ({
          id: s.id,
          name: s.sample,
        }));
        commit('setSampleTypes', sampleTypesMapped);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getSample({ rootState }, sample) {
      try {
        const xhr = await Api.getEtlSample(
          rootState.contact.company,
          rootState.contact.address,
          sample
        );
        const response = JSON.parse(xhr.response);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getSampleTypes({ rootState }) {
      try {
        const xhr = await Api.getEtlSampleTypes(
          rootState.contact.company,
          rootState.contact.address
        );
        const response = JSON.parse(xhr.response);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getDestinationCountries({ commit, rootState }) {
      try {
        const xhr = await Api.getDestinationCountries(
          rootState.contact.company,
          rootState.contact.address,
          rootState.riskAnalysisFilter?.selectedSampleTypes?.id
        );
        const response = JSON.parse(xhr.response) ?? [];
        const orderedCountries = response.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        commit('setOriginCountries', orderedCountries);
        commit('setDestinationCountries', orderedCountries);

        // const responseTranslated = response.map((x) => {
        //   const newKeyValuePair = countryTranslationServiceEs.getKeyValuePairByCode(
        //     x.code
        //   );
        //   return newKeyValuePair || x;
        // });
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getDataEntityCountries({ rootState }) {
      try {
        const xhr = await Api.getEntityV2(
          {
            sampleType:
              rootState.riskAnalysisFilter.selectedSampleTypes.id,
            lmrOrigin:
              rootState.riskAnalysisFilter.selectedOriginCountry.code,
            lmrsDestiny:
              rootState.riskAnalysisFilter
                .selectedDestinationCountries,
          },
          rootState.contact.company,
          rootState.contact.address
        );
        const response = JSON.parse(xhr.response);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    callStoreWithFilters({ commit }, params) {
      EventBus.$emit('RiskAnalysisPage', params);
    },
    clearFilteredData({ commit }, params) {
      EventBus.$emit('RiskAnalysisPage', params);
    },
    setSampleTypes({ commit }, value) {
      commit('setSampleTypes', value);
    },
    setOriginCountries({ commit }, value) {
      commit('setOriginCountries', value);
    },
    setDestinationCountries({ commit }, value) {
      commit('setDestinationCountries', value);
    },
  },
  mutations: {
    setSampleTypes(state, value) {
      state.sampleTypes = value;
    },
    setOriginCountries(state, value) {
      state.originCountries = value;
    },
    setDestinationCountries(state, value) {
      state.destinationCountries = value;
    },
  },
};
